/* No external dependencies. Native dialog, one active video, editor-safe cleanup. */
(() => {
  if (customElements.get('ms-about')) return;
  class MagicshineAbout extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.choices = Array.from(this.querySelectorAll('[data-select]'));
      this.index = Math.max(0, this.panels.findIndex(p => !p.hidden));
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-select')) this.select(Number(button.dataset.select), true);
        if (button.hasAttribute('data-next')) this.select(this.index + 1, true);
        if (button.hasAttribute('data-prev')) this.select(this.index - 1, true);
        if (button.hasAttribute('data-video-open')) this.openVideo(button.dataset.videoOpen, button);
        if (button.hasAttribute('data-image-open')) this.openDialog(button);
        if (button.hasAttribute('data-close')) this.closeDialog();
      }, options);
      this.addEventListener('keydown', event => {
        const choice = event.target.closest('[data-select]');
        if (!choice) return;
        let next;
        if (event.key === 'ArrowRight') next = this.index + 1;
        if (event.key === 'ArrowLeft') next = this.index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.panels.length - 1;
        if (next !== undefined) {
          event.preventDefault(); this.select(next, true);
          this.choices[this.index]?.focus({ preventScroll: true });
        }
      }, options);
      const swipe = this.querySelector('[data-swipe]');
      if (swipe) {
        swipe.addEventListener('touchstart', e => { this.touch = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }; }, { ...options, passive: true });
        swipe.addEventListener('touchend', e => {
          if (!this.touch) return;
          const dx = e.changedTouches[0].clientX - this.touch.x;
          const dy = e.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1), true);
          this.touch = null;
        }, { ...options, passive: true });
      }
      if (this.dialog) {
        this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.closeDialog(); }, options);
        this.dialog.addEventListener('close', () => this.cleanupDialog(), options);
      }
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(p => p.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index, false);
      }, options);
      if (this.panels.length) this.select(this.index, false);
      this.querySelectorAll('[data-prev],[data-next]').forEach(b => b.disabled = this.panels.length < 2);
    }
    select(index, userAction) {
      if (!this.panels.length) return;
      this.index = (index + this.panels.length) % this.panels.length;
      this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
      this.choices.forEach((choice, i) => {
        choice.setAttribute('aria-pressed', String(i === this.index));
      });
      this.querySelectorAll('[data-counter]').forEach(counter => {
        counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.panels.length).padStart(2, '0')}`;
      });
      if (userAction) {
        const choice = this.choices[this.index];
        const parent = choice?.parentElement;
        if (parent && parent.scrollWidth > parent.clientWidth) {
          parent.scrollTo({ left: choice.offsetLeft - parent.offsetLeft - (parent.clientWidth - choice.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
    }
    openVideo(id, opener) {
      const template = Array.from(this.querySelectorAll('template[data-video-template]')).find(t => t.dataset.videoTemplate === id);
      const mount = this.querySelector('[data-video-mount]');
      if (!template || !mount || !template.content.children.length) return;
      mount.replaceChildren(template.content.cloneNode(true));
      const iframe = mount.querySelector('iframe');
      if (iframe) {
        const videoId = encodeURIComponent(iframe.dataset.videoId);
        iframe.src = iframe.dataset.provider === 'youtube'
          ? `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`
          : `https://player.vimeo.com/video/${videoId}?autoplay=1&dnt=1`;
      }
      this.openDialog(opener);
      const video = mount.querySelector('video');
      if (video) { const pending = video.play(); if (pending?.catch) pending.catch(() => {}); }
    }
    openDialog(opener) {
      if (!this.dialog || this.dialog.open) return;
      document.querySelectorAll('ms-about dialog[open]').forEach(d => d.close());
      this.opener = opener;
      this.dialog.showModal();
      document.body.classList.add('msa-modal-open');
    }
    closeDialog() { if (this.dialog?.open) this.dialog.close(); }
    cleanupDialog() {
      const mount = this.querySelector('[data-video-mount]');
      mount?.querySelectorAll('video').forEach(v => v.pause());
      mount?.replaceChildren();
      if (!document.querySelector('ms-about dialog[open]')) document.body.classList.remove('msa-modal-open');
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.closeDialog();
      this.cleanupDialog();
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('ms-about', MagicshineAbout);
})();
